import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { useState } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { useIntl, FormattedMessage } from 'react-intl';
import useDataLayer from '../../hooks/use-data-layer.js';
import computeLinkProps from '../../util/compute-link-props.js';
import getPortalContainer from '../../util/get-portal-container.js';
import Button from '../common/button.js';
import CaptchaText from '../common/captcha-text.js';
import DataLayer from '../common/data-layer.js';
import RichMessage from '../common/rich-message.js';
import style from './contact-modal.style.js';
import { jsxs, jsx, Fragment } from '@emotion/react/jsx-runtime';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CloseIcon = function CloseIcon(props) {
  return jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: jsx("path", {
      d: "M10.939 12 7.47 15.47a.749.749 0 1 0 1.06 1.06L12 13.061l3.47 3.469a.749.749 0 1 0 1.06-1.06L13.061 12l3.469-3.47a.749.749 0 1 0-1.06-1.06L12 10.939 8.53 7.47a.749.749 0 1 0-1.06 1.06L10.939 12Z"
    })
  }));
};

CloseIcon.defaultProps = {
  viewBox: "0 0 24 24"
};
var errorImage = "data:image/png;base64,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";

var ContactModal = function ContactModal(_ref) {
  var content = _ref.content,
      show = _ref.show,
      modalState = _ref.modalState,
      noTerms = _ref.noTerms,
      inputs = _ref.inputs,
      errors = _ref.errors,
      setInputs = _ref.setInputs,
      setErrors = _ref.setErrors,
      onAction = _ref.onAction,
      contactWithSale = _ref.contactWithSale;
  var intl = useIntl();

  var _useDataLayer = useDataLayer(),
      pushDataLayerMessage = _useDataLayer.pushDataLayerMessage;

  var setInput = function setInput(name, type) {
    return function (event) {
      var value = event.target.value;

      if (type === 'name') {
        value = value.replace(/[^a-zA-Z\u0e00-\u0e7f]/g, '');
      }

      if (type === 'phone-number') {
        value = value.replace(/[^0-9]/g, '').substring(0, 10);
      }

      setInputs(_objectSpread(_objectSpread({}, inputs), {}, _defineProperty({}, name, value)));
      setErrors(_objectSpread(_objectSpread({}, errors), {}, _defineProperty({}, name, '')));
    };
  };

  var setChecked = function setChecked(checked) {
    setInputs(_objectSpread(_objectSpread({}, inputs), {}, {
      checked: checked
    }));
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      submitting = _useState2[0],
      setSubmitting = _useState2[1];

  var submit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var defaultPackageId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              defaultPackageId = content.packages.length === 1 ? content.packages[0].id.toString() : '';
              inputs = _objectSpread(_objectSpread({}, inputs), {}, {
                packageId: inputs.packageId || defaultPackageId
              });
              _context.prev = 2;
              setErrors({});
              setSubmitting(true);
              _context.next = 7;
              return onAction('submit-form', {
                inputs: inputs
              });

            case 7:
              pushDataLayerMessage('ContactModal@submitFormSuccess', {
                inputs: inputs
              });
              _context.next = 12;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](2);

            case 12:
              _context.prev = 12;
              setSubmitting(false);
              return _context.finish(12);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 10, 12, 15]]);
    }));

    return function submit() {
      return _ref2.apply(this, arguments);
    };
  }();

  var showTerms = function showTerms(event) {
    event.preventDefault();
    onAction('show-terms');
  };

  var container = getPortalContainer();
  return jsxs(Modal, {
    css: style.modal,
    centered: true,
    show: show,
    container: container,
    children: [jsx("div", {
      css: style.close,
      onClick: function onClick() {
        return onAction('close-modal');
      },
      children: jsx(CloseIcon, {
        css: style.closeIcon
      })
    }), modalState === 'form' && jsxs(Fragment, {
      children: [jsx("div", {
        css: style.header,
        children: content.sendLeadHeader
      }), jsxs("div", {
        className: "p-2 pb-3",
        children: [jsx("div", {
          css: style.formHeaderText,
          children: jsx(FormattedMessage, {
            id: "InternetPackage.contactFormTitle",
            defaultMessage: "Contact Information"
          })
        }), errors.submit === 'incomplete-form' && jsx(DataLayer, {
          selector: "ContactModal.contactFormIncompleteText",
          triggers: ['appear'],
          context: {
            errors: errors
          },
          render: function render(ref) {
            return jsx("div", {
              ref: ref,
              css: style.submitError,
              children: jsx(FormattedMessage, {
                id: "InternetPackage.contactFormIncompleteText",
                defaultMessage: "Please complete all required fields."
              })
            });
          }
        }), jsx(Form.Group, {
          className: "mt-2",
          children: jsx(Form.Control, {
            css: style.formControl,
            type: "text",
            placeholder: intl.formatMessage({
              id: 'firstName'
            }),
            value: inputs.firstName,
            onChange: setInput('firstName', 'name'),
            isInvalid: !!errors.firstName
          })
        }), jsx(Form.Group, {
          className: "mt-2",
          children: jsx(Form.Control, {
            css: style.formControl,
            type: "text",
            placeholder: intl.formatMessage({
              id: 'lastName'
            }),
            value: inputs.lastName,
            onChange: setInput('lastName', 'name'),
            isInvalid: !!errors.lastName
          })
        }), jsx(Form.Group, {
          className: "mt-2",
          children: jsx(Form.Control, {
            css: style.formControl,
            type: "text",
            placeholder: intl.formatMessage({
              id: 'phoneNumber'
            }),
            value: inputs.phoneNumber,
            onChange: setInput('phoneNumber', 'phone-number'),
            isInvalid: !!errors.phoneNumber
          })
        }), content.packages.length > 1 && jsx(Form.Group, {
          className: "mt-2",
          children: jsxs(Form.Select, {
            css: style.formControl,
            value: inputs.packageId,
            onChange: setInput('packageId'),
            isInvalid: !!errors.packageId,
            children: [jsx("option", {
              value: "",
              disabled: true,
              children: intl.formatMessage({
                id: 'InternetPackage.packagePlaceholderText'
              })
            }), content.packages.map(function (pack) {
              return jsx("option", {
                value: pack.id,
                children: pack.name
              }, pack.id);
            })]
          })
        }), !noTerms && jsx("div", {
          className: "d-flex justify-content-center mt-2",
          children: jsx(Form.Check, {
            css: style.formCheck,
            children: jsxs(Form.Check.Label, {
              children: [jsx(Form.Check.Input, {
                checked: inputs.checked,
                onChange: function onChange(event) {
                  return setChecked(event.target.checked);
                }
              }), jsx(FormattedMessage, {
                id: "InternetPackage.iAgreeText",
                defaultMessage: "I agree to the Terms and Conditions",
                values: {
                  action: function action(chunks) {
                    return jsx(DataLayer, {
                      selector: "ContactModal.termsButton",
                      triggers: ['click'],
                      render: function render(ref) {
                        return jsx("span", {
                          ref: ref,
                          css: style.termsText,
                          onClick: showTerms,
                          children: chunks
                        });
                      }
                    });
                  }
                }
              })]
            })
          })
        }), errors.submit === 'terms-not-checked' && jsx("div", {
          css: style.checkboxError,
          children: jsx(FormattedMessage, {
            id: "InternetPackage.iAgreeNotCheckedText",
            defaultMessage: "Please agree to the Terms and Conditions before proceeding."
          })
        }), jsxs("div", {
          className: "d-flex justify-content-center mt-3",
          children: [jsx(DataLayer, {
            selector: "ContactModal.submitButton",
            context: {
              inputs: inputs
            },
            triggers: ['click'],
            render: function render(ref) {
              return jsx(Button, {
                ref: ref,
                disabled: submitting,
                onClick: submit,
                children: jsx(FormattedMessage, {
                  id: "InternetPackage.submitButtonText",
                  defaultMessage: "Submit"
                })
              });
            }
          }), contactWithSale.status && jsx(DataLayer, {
            selector: "ContactModal.chatWithSaleStaffButton",
            context: {
              inputs: inputs
            },
            triggers: ['click'],
            render: function render(ref) {
              return jsx(Button, _objectSpread(_objectSpread({
                ref: ref
              }, computeLinkProps(contactWithSale.link)), {}, {
                className: "ms-2",
                children: contactWithSale.name
              }));
            }
          })]
        }), jsx(CaptchaText, {
          className: "mt-3 mx-2 text-center"
        })]
      })]
    }), modalState === 'error' && jsxs(Fragment, {
      children: [jsx("div", {
        css: style.resultHeader
      }), jsxs("div", {
        className: "px-2 py-3",
        children: [jsx("img", {
          css: style.resultIcon,
          src: errorImage,
          alt: "error"
        }), errors.submit === 'already-in-queue' && jsxs(Fragment, {
          children: [jsx(DataLayer, {
            selector: "ContactModal.alreadyInQueueErrorForm",
            triggers: ['appear'],
            context: {
              inputs: inputs
            },
            render: function render(ref) {
              return jsx("div", {
                ref: ref,
                css: style.resultText,
                children: jsx(RichMessage, {
                  id: "InternetPackage.alreadyInQueueErrorText",
                  defaultMessage: "You are already in the queue!",
                  xTags: ['title']
                })
              });
            }
          }), jsx("div", {
            className: "d-flex justify-content-center mt-3",
            children: jsx(DataLayer, {
              selector: "ContactModal.doneButton",
              triggers: ['click'],
              render: function render(ref) {
                return jsx(Button, {
                  ref: ref,
                  variant: "outlined",
                  onClick: function onClick() {
                    return onAction('close-modal');
                  },
                  children: jsx(FormattedMessage, {
                    id: "InternetPackage.backButtonText",
                    defaultMessage: "Back"
                  })
                });
              }
            })
          })]
        }), errors.submit === 'many-request' && jsxs(Fragment, {
          children: [jsx(DataLayer, {
            selector: "ContactModal.manyRequestErrorForm",
            triggers: ['appear'],
            context: {
              inputs: inputs
            },
            render: function render(ref) {
              return jsx("div", {
                ref: ref,
                css: style.resultText,
                children: jsx(RichMessage, {
                  id: "InternetPackage.manyRequestErrorText",
                  defaultMessage: "You over submit your submission, please try again later.",
                  xTags: ['title']
                })
              });
            }
          }), jsx("div", {
            className: "d-flex justify-content-center mt-3",
            children: jsx(DataLayer, {
              selector: "ContactModal.doneButton",
              triggers: ['click'],
              render: function render(ref) {
                return jsx(Button, {
                  ref: ref,
                  variant: "outlined",
                  onClick: function onClick() {
                    return onAction('close-modal');
                  },
                  children: jsx(FormattedMessage, {
                    id: "InternetPackage.backButtonText",
                    defaultMessage: "Back"
                  })
                });
              }
            })
          })]
        }), errors.submit === 'unknown' && jsxs(Fragment, {
          children: [jsx(DataLayer, {
            selector: "ContactModal.unknownErrorForm",
            triggers: ['appear'],
            context: {
              inputs: inputs
            },
            render: function render(ref) {
              return jsx("div", {
                ref: ref,
                css: style.resultText,
                children: jsx(RichMessage, {
                  id: "InternetPackage.contactFormErrorText",
                  defaultMessage: "Something went wrong!",
                  xTags: ['title']
                })
              });
            }
          }), jsx("div", {
            className: "d-flex justify-content-center mt-3",
            children: jsx(DataLayer, {
              selector: "ContactModal.retryButton",
              triggers: ['click'],
              render: function render(ref) {
                return jsx(Button, {
                  ref: ref,
                  variant: "outlined",
                  onClick: function onClick() {
                    return onAction('retry-form');
                  },
                  children: jsx(FormattedMessage, {
                    id: "InternetPackage.retryButtonText",
                    defaultMessage: "Retry"
                  })
                });
              }
            })
          })]
        })]
      })]
    })]
  });
};

export { ContactModal as default };